import React, { useState, useRef, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';
import { ws_pot_irrigate, ws_pot_irrigate_stop, ws_calibrateIrrigationTime } from '../../../api/api_wsFunctions';

const CalibrateIrrigationTime = () => {
    const navigate = useNavigate();
    const location = useLocation(); 
    const { hubSN, potSN } = location.state;
    const { translations } = useLanguage();
    const [timer, setTimer] = useState(0);
    const [inputTime, setInputTime] = useState('');
    const [timeUnit, setTimeUnit] = useState('seconds');
    const [timerActive, setTimerActive] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const startTimer = (hubSN, potSN) => {
        if (timerActive) return;
        setTimerActive(true);
        ws_pot_irrigate(hubSN, potSN);

        const startTime = Date.now();
        intervalRef.current = setInterval(() => {
            const newTime = Math.floor((Date.now() - startTime) / 1000);
            if (newTime >= 1800) { // 30 minutes limit
                clearInterval(intervalRef.current);
                setTimerActive(false);
            } else {
                setTimer(newTime);
            }
        }, 1000);
    };

    const stopTimer = (hubSN, potSN) => {
        if (!timerActive) return;
        clearInterval(intervalRef.current);
        setTimerActive(false);
        ws_pot_irrigate_stop(hubSN, potSN);
        setInputTime(timer.toString());
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleTimeSubmit = () => {
        const seconds = timeUnit === 'minutes' ? parseInt(inputTime) * 60 : parseInt(inputTime);
        ws_calibrateIrrigationTime(hubSN, potSN, seconds);
        navigate(-1);
    };

    return (
        <div className="sm-page">
            <div className="sm-container">
                <div className="header">
                    <button onClick={handleBack} className="back-button">&#8592;</button>
                    <h1>{translations.title_advanced_hub_settings}</h1>
                </div>
                <div className="timer-container">
                    <p>{`${translations.timer}: ${timer} ${translations.seconds}`}</p>
                    <button onClick={() => startTimer(hubSN, potSN)} disabled={timerActive}>{translations.start}</button>
                    <button onClick={() => stopTimer(hubSN, potSN)} disabled={!timerActive}>{translations.stop}</button>
                </div>
                <div className="manual-time-input">
                    <input type="number" value={inputTime} onChange={e => setInputTime(e.target.value)} className="general-input" />
                    <select value={timeUnit} onChange={e => setTimeUnit(e.target.value)}>
                        <option value="seconds">{translations.seconds}</option>
                        <option value="minutes">{translations.minutes}</option>
                    </select>
                </div>
                <button onClick={handleTimeSubmit} className="general-button">{translations.apply}</button>
            </div>
        </div>
    );
};

export default CalibrateIrrigationTime;
